export const getUniqueArray = <T>(input: T[]): T[] => {
    return [...new Set<T>(input)];
};
